module.exports = {
  raceCalendar: [
    {
      title: 'Season 4. More Electrifying.',
      description: 'On December 2 and 3, Faraday Future Dragon Racing launches Season 4 by returning to Hong Kong, where we made our exhilarant Formula E debut last year. Concluding in Montreal on July 28 and 29, Season 4 will ramp up the power - from 170kw to 180kw – for even faster and more riveting races.',
      dates: [
        {
          rounds: [
            { number: 1 },
            { number: 2 }
          ],
          date: 'DECEMBER 2-3, 2017',
          title: 'Hong Kong ePrix',
          description: 'Coming soon.'
        },
        {
          rounds: [
            { number: 3 }
          ],
          date: 'NOVEMBER 13, 2018',
          title: 'Marrakesh ePrix',
          description: 'Coming soon.'
        },
        {
          rounds: [
            { number: 4 }
          ],
          date: 'FEBRUARY 3, 2018',
          title: 'Santiago ePrix',
          description: 'Coming soon.'
        },
        {
          rounds: [
            { number: 5 }
          ],
          date: 'MARCH 3, 2018',
          title: 'Mexico City ePrix',
          description: 'Coming soon.'
        },
        {
          rounds: [
            { number: 6 }
          ],
          date: 'MARCH 17, 2018',
          title: 'Sao Paulo ePrix',
          description: 'Coming soon.'
        },
        {
          rounds: [
            { number: 7 }
          ],
          date: 'APRIL 14, 2018',
          title: 'Rome ePrix',
          description: 'Coming soon.'
        },
        {
          rounds: [
            { number: 8 }
          ],
          date: 'APRIL 28, 2018',
          title: 'Paris ePrix',
          description: 'Coming soon.'
        },
        {
          rounds: [
            { number: 9 },
          ],
          date: 'MAY 19, 2018',
          title: 'TBD',
          description: 'Coming soon.'
        },
        {
          rounds: [
            { number: 10 },
          ],
          date: 'JUNE 9, 2018',
          title: 'TBD',
          description: 'Coming soon.'
        },
        {
          rounds: [
            { number: 11 },
            { number: 12 }
          ],
          date: 'JULY 7-8, 2018',
          title: 'New York ePrix',
          description: 'Coming soon.'
        },
        {
          rounds: [
            { number: 13 },
            { number: 14 }
          ],
          date: 'JULY 28-29, 2018',
          title: 'Montreal ePrix',
          description: 'Coming soon.'
        }
      ],
      'moreURL': 'http://www.fiaformulae.com/en/calendar/'
    },
    {
      title: 'Season 3. It Begins.',
      description: 'Faraday Future Dragon Racing made its debut at the first race of Formula E’s third season in Hong Kong along the beautiful Harbourfront. From October 9 to July 30, fourteen rigorous road circuits will push our team and our technology to the limit.<br /><br />The zero-emission, low-decibel powertrains allow Formula E to take place on the most diverse and challenging street circuits in the world, including cities that have never hosted a major motorsports event before.',
      dates: [
        {
          rounds: [
            { number: 1 }
          ],
          date: 'OCTOBER 09, 2016',
          title: 'Hong Kong ePrix',
          description: 'Season 3 kicked off in the heart of Hong Kong, along the iconic urban coastline of Victoria Harbour.'
        },
        {
          rounds: [
            { number: 2 }
          ],
          date: 'NOVEMBER 12, 2016',
          title: 'Marrakesh ePrix',
          description: 'Formula E’s first race in Africa debuted in the host city of the COP22 UN Climate Change Conference.'
        },
        {
          rounds: [
            { number: 3 }
          ],
          date: 'FEBRUARY 18, 2017',
          title: 'Buenos Aires ePrix',
          description: 'Formula E returns to the beautiful Puerto Madero Street Circuit – the only venue that has been featured in all three seasons.'
        },
        {
          rounds: [
            { number: 4 }
          ],
          date: 'APRIL 01, 2017',
          title: 'Mexico City ePrix',

          description: 'A mile above sea level, the historic Autodromo Hermanos Rodriguez is expected to be the one of the most popular races of the season.'
        },
        {
          rounds: [
            { number: 5 }
          ],
          date: 'May 13, 2017',
          title: 'Monaco ePrix',

          description: 'Tight corners and narrow streets make the illustrious Circuit de Monaco one of the most demanding courses of any racing series.'
        },
        {
          rounds: [
            { number: 6 }
          ],
          date: 'May 20, 2017',
          title: 'Paris ePrix',

          description: 'A year after a sell-out crowd packed the grandstands lining the famous Les Invalides complex, we return for the season’s first back-to-back race.'
        },
        {
          rounds: [
            { number: 7 },
            { number: 8 }
          ],
          date: 'June 10, 2017',
          title: 'Berlin ePrix',

          description: 'Race fans will get double the action at the Berlin ePrix, which will take place over two races on a completely redesigned circuit at Tempelhof Airport.'
        },
        {
          rounds: [
            { number: 9 },
            { number: 10 }
          ],
          date: 'July 15, 2017',
          title: 'New York ePrix',
          description: 'The storied skyline of Manhattan will form a legendary backdrop for New York City’s historic first ePrix in south Brooklyn.'
        },
        {
          rounds: [
            { number: 11 },
            { number: 12 }
          ],
          date: 'July 30, 2017',
          title: 'Montreal ePrix',
          description: 'The season 3 championship finale culminates in a climactic double-header along the banks of St. Lawrence River.'
        }
      ],
      moreURL: 'http://www.fiaformulae.com/en/results/race-results/season/2022016/round/12'
    },
  ]
};
